module.exports = __webpack_public_path__ + "static/img/mobile_xxyj_banner.35f193c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_xxyj_banner.png
// module id = U7sO
// module chunks = 21